/**
 * file is common js because used by webpack
 *
 * TODO: look into using typescript with webpack
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const mmVendorsProdURLs = require("../mmVendorProdUrls.json");

const matchHostToConfig = () => {
  const { hostname, host } = window.location;

  // Prod Configs
  if (mmVendorsProdURLs.some((hostUrl) => hostname.includes(hostUrl)))
    return "mm.prod";
  if (hostname === "appengage.sinch.com") return "engage.prod";
  if (
    hostname.includes("cop.sinch.se") ||
    hostname.includes("cop.saas.sinch.com")
  )
    return "cop.prod";
  // Staging Configs
  if (
    hostname.includes("stg.messagemedia.com") ||
    hostname.includes("stg.mmd.zone") ||
    hostname.includes("mm.web.labengage.sinch.com")
  )
    return "mm.stg";
  if (
    hostname.includes("stagingengage.sinch.com") ||
    host.includes("localhost:3000")
  )
    return "engage.stg.aws";
  if (
    hostname.includes("cop.stg.saas.sinch.com") ||
    hostname.includes("cop-stage.sinch.se")
  )
    return "cop.stg";

  // QA Configs
  if (
    hostname.includes("qa.messagemedia.com") ||
    hostname.includes("qa.mmd.zone")
  )
    return "mm.qa";
  if (
    hostname.includes("stagingengage.messengerpeople.com") ||
    hostname.includes("labengage.sinch.com") ||
    host.includes("localhost:3001")
  )
    return "engage.stg.gcp";
  if (
    hostname.includes("cop.dev.saas.sinch.com") ||
    hostname.includes("cop-dev.sinch.se") ||
    host.includes("localhost:3002")
  )
    return "cop.dev";

  // Local configs
  if (host.includes("localhost")) return "mm.local";

  // other entry's URLs are a bit more predictable, so let's use mm as default
  return "mm.prod";
};

module.exports.matchHostToConfig = matchHostToConfig;

/**
 *
 * @returns "mm" | "engage" | "cop"
 */
const getEntryFromURL = () => matchHostToConfig().split(".")[0];

module.exports.getEntryFromURL = getEntryFromURL;

/**
 * @returns "prod" | "qa" | "stg" | "dev" | "local" | "unknown"
 */
const getEnvFromURL = () => matchHostToConfig().split(".")[1] ?? "unknown";

module.exports.getEnvFromURL = getEnvFromURL;
